import React, { Component } from 'react';
import './Profile.css';
import NabarClient from '../Components/NabarClient/NabarClient';
import HeaderTool from '../Components/HeaderTool/HeaderTool';
import personlg from '../../image/personlg.svg'
import iconpen from '../../image/iconpen.svg'
import closeicon from '../../image/closeicon.svg'
import { LinkAPI } from '../../API/API'
import MapsNewOrder from '../Components/Maps/MapsNewOrder';
import HandleRes from '../Components/HandleRes/HandleRes';
import searchbule from '../../image/searchbule.svg';
import axios from 'axios'
import { Link } from 'react-router-dom';

class Profile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            name: "",
            email: "",
            phone: "",
            oldphone:"",
            usecompanyinfo: "",
            password: "",
            Newpassword: "",
            numberoforders: "",
            companyname: "",
            companycity: "",
            CompanyPhone:"",
            address_name: "",
            address_alias: "",
            coordinates: [],
            ZipCode: "",
            code: "",
            nameError: "",
            emailError: "",
            phoneError: "",
            passwordError: "",
            NewpasswordError: "",
            address_nameError: "",
            address_aliasError: "",
            ZipCodeError: "",
            codeError: "",
             CompanyPhoneError: "",
             address_aliasError: "",
             companycityError: "",
             companynameError: "",
            Verify: false,
            res_doneEdit: false,
            res_doneChangeEmail: false,
            res_doneChangepassword: false,
            res_doneChangephone: false,
            networkError: false,
            errordatamessage: false,
            errordatamessagetext: '',
            errordataEmailmessage: false,
            errordatamessageEmailtext: '',
            hasError: false,
        }
        this.getinfo()
    }
    getinfo = () => {
        const Token = localStorage.getItem("userToken")

        axios.get(`${LinkAPI}/api/businessowner/getinfo`, {
            headers: {
                Authorization: `${Token}`
            }
        }).then(res => {
            this.setState({
                data: res.data.businessOwner
            })
            this.setState({
                name: res.data.businessOwner.name,
                email: res.data.businessOwner.email,
                phone: res.data.businessOwner.phone.replace(/^20+/, ''),
                oldphone: res.data.businessOwner.phone.replace(/^20+/, ''),
                name: res.data.businessOwner.name,
                usecompanyinfo: res.data.businessOwner.usecompanyinfo,
                numberoforders: res.data.businessOwner.numberoforders,
                companyname: res.data.businessOwner.companyinfo.companyname,
                companycity: res.data.businessOwner.companyinfo.companycity,
                ZipCode: res.data.businessOwner.companyinfo.companyzipcode,
                CompanyPhone:res.data.businessOwner.companyinfo.phone.replace(/^20+/, ''),
                address_name: res.data.businessOwner.companyinfo.address.address_name,
                address_alias: res.data.businessOwner.companyinfo.address.address_alias,
                coordinates: res.data.businessOwner.companyinfo.address.location.coordinates,
                networkError: false,
                errordatamessage: false,
                errordatamessagetext: '',
                hasError: false,
            })
        }).catch(error => {
            this.HandleError(error)
        })
    }

    HandleError = (error) => {
        if (!error.response) {
            this.setState({
                networkError: true
            })
        } else if (error.response.status === 402) {
            localStorage.removeItem("userToken")
            window.location.replace("/SignIn");
        } else if (error.response.data.message) {
            this.setState({
                errordatamessage: true,
                errordatamessagetext: error.response.data.message
            })
        } else {
            this.setState({
                hasError: true,
            })
        }
    }
    resetsomvar=()=>{
        this.setState({
            password: "",
            Newpassword: "",
            code: "",

        })
    }
    handleChange = event => {
        const isCheckbox = event.target.type === "checkbox";
        this.setState({
            [event.target.name]: isCheckbox
                ? event.target.checked
                : event.target.value
        });
    };
    setStatecoordinatesaddress_alias = (coordinates, address_name) => {
        this.setState({
            coordinates: coordinates,
            address_name: address_name

        })
    
    }
    validateinfo = () => {
        let nameError = "";
        let ZipCodeError = "";
        let CompanyPhoneError="";
        let address_nameError="";
        let address_aliasError="";
        let companycityError="";
        let companynameError="";

        
        if (this.state.name.length < 2 || !isNaN(this.state.name)) {
            nameError = "write your name correct";
        }
        if (this.state.companyname.length < 2 || !isNaN(this.state.companyname)) {
            companynameError = "write your company name correct";
        }
        if (this.state.companycity.length < 2 || !isNaN(this.state.companycity)) {
            companycityError = "write your company city correct";
        }
        if (this.state.ZipCode.length!==5 ||  isNaN(this.state.ZipCode)) {
            ZipCodeError = "invalid Zip Code";
        }
        
        if (isNaN(this.state.CompanyPhone) || this.state.CompanyPhone.length < 10 ||this.state.CompanyPhone.length >11) {
            CompanyPhoneError = "wrong Company Phone ";
        }
        if (this.state.address_name.length < 5 || !isNaN(this.state.address_name)) {
            address_nameError = "select your location correct";
        }
        if (this.state.address_alias.length < 5 || !isNaN(this.state.address_alias)) {
            address_aliasError = "write your Address correct";
        }
        if (!this.state.coordinates) {
            address_nameError = "select your location correct";
        }
        if (nameError ||companynameError||companycityError|| ZipCodeError||address_nameError||address_aliasError ||CompanyPhoneError) {
            this.setState({ nameError,companynameError, companycityError,ZipCodeError, address_nameError,CompanyPhoneError,address_aliasError });
            return false;
        }

        return true;
    };
    validateemail = () => {
        let emailError = "";
        let passwordError = "";
        if (!this.state.email.includes("@")) {
            emailError = "invalid email";
        }


        if (this.state.password.length < 8) {
            passwordError = "Use 8 characters or more for your password";
        }


        if (emailError || passwordError) {
            this.setState({ emailError, passwordError });
            return false;
        }

        return true;
    };
    validatephone = () => {
        let phoneError = "";
        let passwordError = "";
        if (isNaN(this.state.phone) || this.state.phone.length < 10) {
            phoneError = "write phone Numper ";
        }
        if (this.state.password.length < 8) {
            passwordError = "Use 8 characters or more for your password";
        }


        if (phoneError || passwordError) {
            this.setState({ phoneError, passwordError });
            return false;
        }

        return true;
    };
    validatepassword = () => {
        let passwordError = "";
        let NewpasswordError = "";
        if (this.state.password.length < 8) {
            passwordError = "Use 8 characters or more for your password";
        }

        if (this.state.Newpassword.length < 8) {
            NewpasswordError = "Use 8 characters or more for your password";
        }

        if (passwordError || NewpasswordError) {
            this.setState({ passwordError, NewpasswordError });
            return false;
        }

        return true;
    };
    validateVerify = () => {
        let codeError = "";

        if (this.state.code.length !== 4 || isNaN(this.state.code)) {
            codeError = "write your code correct";
        }
        if (codeError) {
            this.setState({ codeError });
            return false;
        }
        return true;
    };
    handleSubmitEditinfo = event => {
        event.preventDefault();
        const Token = localStorage.getItem("userToken")
        const { name, usecompanyinfo, companyname, companycity, address_name, address_alias, coordinates, ZipCode,CompanyPhone } = this.state
        const isValid = this.validateinfo();
        if (isValid) {
            axios.put(`${LinkAPI}/api/businessowner/editinfo`, {
                name: name,
                usecompanyinfo: usecompanyinfo,
                companyinfo: {
                    companyname: companyname,
                    companycity: companycity,
                    companyzipcode: ZipCode,
                    phone:20+CompanyPhone.replace(/^0+/, ''),
                    address: {
                        address_name: address_name,
                        address_alias: address_alias,
                        location: {
                            type: "point",
                            coordinates: coordinates
                        }
                    }
                }
            }, {
                headers: {
                    Authorization: `${Token}`
                }
            }).then(res => {
                this.setState({
                    nameError: "",
                    ZipCodeError: "",
                    CompanyPhoneError: "",
             address_aliasError: "",
             companycityError: "",
             companynameError: "",
                    res_doneEdit: true,
                    networkError: false,
                    errordatamessage: false,
                    errordatamessagetext: '',
                    hasError: false,

                })
                setTimeout(() => {
                    this.setState({
                        res_doneEdit: false
                    })
                }, 2000);
            })
                .catch(error => {
                    this.HandleError(error)
                })


        }
    };
    handleSubmitemail = event => {
        event.preventDefault();
        const { email, password } = this.state
        const isValid = this.validateemail();
        if (isValid) {
            const Token = localStorage.getItem("userToken")
            axios.put(`${LinkAPI}/api/businessowner/changeemail`, { email: email, password: password }, {
                headers: {
                    Authorization: `${Token}`
                }
            }).then(res => {
                localStorage.setItem("userToken", res.data.token)

                this.setState({
                    emailError: "",
                    passwordError: "",
                    res_doneChangeEmail: true,
                    networkError: false,
                    errordatamessage: false,
                    errordatamessagetext: '',
                    errordataEmailmessage: false,
                    hasError: false,
                    emailError: "",
                        passwordError: "",
                })
                setTimeout(() => {
                    this.setState({
                        res_doneChangeEmail: false,
                        
                    })
                }, 15000);
            })
                .catch(error => {
                    if (!error.response) {
                        this.setState({
                            networkError: true
                        })
                    } else if (error.response.status === 402) {
    
                        window.location.replace("/SignIn");
                    } else if (error.response.data.message) {
                        this.setState({
                            emailError: "",
                            passwordError: "",
                            errordataEmailmessage: true,
                            errordatamessageEmailtext: error.response.data.message
                        })
                    } else {
                        this.setState({
                            hasError: true,
                        })
                    }


                })


        }

    };
    handleSubmitphone = event => {
        event.preventDefault();
        const { phone, password } = this.state
        const Token = localStorage.getItem("userToken")
        const isValid = this.validatephone();
        if (isValid) {
            axios.put(`${LinkAPI}/api/businessowner/changephone`, { phone:20+phone.replace(/^0+/, ''), password }, {
                headers: {
                    Authorization: `${Token}`
                }
            }).then(res => {
                this.setState({
                    Verify: true,
                    errordataPhonemessage: false,
                    errordatamessage: false,

                    phoneError: "",
                    passwordError: "",
                })
                localStorage.setItem("userToken", res.data.token)

            }).catch(error => {
                if (!error.response) {
                    this.setState({
                        networkError: true,
                    })
                } else if (error.response.status === 402) {

                    window.location.replace("/SignIn");
                } else if (error.response.data.message) {
                    this.setState({
                        phoneError: "",
                        passwordError: "",
                        errordataPhonemessage: true,
                        errordatamessagePhonetext: error.response.data.message
                    })
                } else {
                    this.setState({
                        hasError: true,
                    })
                }
            })

        }
    };
    handleSubmitVerify = event => {
        event.preventDefault();
        const { code } = this.state
        const Token = localStorage.getItem("userToken")
        const isValid = this.validateVerify();
        if (isValid) {
            axios.post(`${LinkAPI}/api/businessowner/confirmchangephone`, { code }, {
                headers: {
                    Authorization: `${Token}`
                }
            }).then(res => {
                this.setState({
                    Verify: false,
                    res_doneChangephone: true,
                    networkError: false,
                    errordataPhoneVerifymessage: false,

                    errordatamessage: false,
                    errordatamessagetext: '',
                    hasError: false,
                })
                localStorage.setItem("userToken", res.data.token)
                setTimeout(() => {
                    this.setState({
                        res_doneChangephone: false
                    })
                }, 2000);

            }).catch(error => {
                if (!error.response) {
                    this.setState({
                        networkError: true,
                    })
                } else if (error.response.status === 402) {

                    window.location.replace("/SignIn");
                } else if (error.response.data.message) {
                    this.setState({
                        codeError: "",
                        errordataPhoneVerifymessage: true,
                        errordatamessagePhoneVerifytext: error.response.data.message
                    })
                } else {
                    this.setState({
                        hasError: true,
                    })
                }
            })

        }
    };
    handleSubmitChangepassword = event => {
        event.preventDefault();
        const { password, Newpassword } = this.state
        const Token = localStorage.getItem("userToken")
        const isValid = this.validatepassword();
        if (isValid) {
            axios.put(`${LinkAPI}/api/businessowner/changepassword`, { oldpassword: password, newpassword: Newpassword }, {
                headers: {
                    Authorization: `${Token}`
                }
            }).then(res => {
                this.setState({
                    networkError: false,
                    errordatamessage: false,
                    errordatamessagetext: '',
                    hasError: false,
                    res_doneChangepassword: true,
                    passwordError: "",
                    NewpasswordError: "",
                    errordatapasswordmessage: false,

                })
                setTimeout(() => {
                    this.setState({
                        
                        res_doneChangepassword: false,

                    })
                }, 2000);
            }).catch(error => {
                if (!error.response) {
                    this.setState({
                        networkError: true,
                    })
                } else if (error.response.status === 402) {

                    window.location.replace("/SignIn");
                } else if (error.response.data.message) {
                    this.setState({
                        passwordError: "",
                        NewpasswordError: "",

                        errordatapasswordmessage: true,
                        errordatamessagepasswordtext: error.response.data.message
                    })
                } else {
                    this.setState({
                        hasError: true,
                    })
                }
            })
        }
    };
    render() {
        document.title ="Kayn | Sign Up"; 
        document.getElementsByTagName("META")[1].content="Kayn Sign Up";
        document.documentElement.lang = 'en';


        const { name, usecompanyinfo, email, phone, password, Newpassword, ZipCode, numberoforders, companyname, companycity,CompanyPhone, address_name, address_alias } = this.state
        return (
            <div>


                <div className="AppEN row  mx-0">
                    <div className="col-md-1 px-0 ">
                        <NabarClient />
                    </div>
                    <div className="  client profile col-md-11 px-lg-5">
                        <HeaderTool />
                        <div className="shadow p-lg-5 p-3 m-1 bg-white ">
                            <p className="col-12 mt-2 p-0 fontsize10  ">
                                <img className="mr-3 iconsm" src={personlg} alt="user kayn" />
                                {name}
                            </p>
                            <p className="fontsize12 mx-5">Total orders: {numberoforders}</p>
                            <p className="col-12 mt-2 p-0 fontsize4 font-weight-bold ">Contact details</p>
                            <hr />
                            <div className="form-row">
                                <div className="col-md-4 col-sm-6  px-2">
                                    <label className="text-muted fontsize12">Full Name</label>
                                    <input type="text" className={"form-control badge-pill p-3 " + (this.state.nameError ? 'is-invalid' : '')} placeholder="Full Name" name="name" value={name} onChange={this.handleChange} />
                                    <div style={{ fontSize: 12, color: "red" }}>
                                        {this.state.nameError}
                                    </div>
                                </div>
                                <div className="col-md-4 col-sm-6 mx-4 my-1 p-4">
                                    <input className="form-check-input" type="checkbox" id="gridCheck" name="usecompanyinfo" value={usecompanyinfo} onChange={this.handleChange} checked={(this.state.usecompanyinfo ? 'checked' : '')} />
                                    <label className="form-check-label fontsize11" htmlFor="gridCheck"  >
                                        Use my company info for delivery
                                </label>
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="col-md-4 col-sm-6 px-2">
                                    <label className="text-muted fontsize12">Company Name</label>
                                    <input type="text" className={"form-control badge-pill p-3 " + (this.state.companynameError ? 'is-invalid' : '')}placeholder="Company Name" name="companyname" value={companyname} onChange={this.handleChange} />
                                    <div style={{ fontSize: 12, color: "red" }}>
                                                        {this.state.companynameError}
                                    </div>
                                </div>
                                <div className="col-md-4 col-sm-6 px-2">
                                    <label className="text-muted fontsize12">Company City</label>
                                    <input type="text" className={"form-control badge-pill p-3 " + (this.state.companycityError ? 'is-invalid' : '')} placeholder="Company City" name="companycity" value={companycity} onChange={this.handleChange} />
                                    <div style={{ fontSize: 12, color: "red" }}>
                                                        {this.state.companycityError}
                                    </div>
                                </div>
                                <div className="col-md-4 col-sm-6 px-2 counter">
                                    <label className="text-muted fontsize12">Company zip code</label>
                                    <input type="number" className={"form-control badge-pill p-3 " + (this.state.ZipCodeError ? 'is-invalid' : '')} placeholder="Company city" name="ZipCode" value={ZipCode} onChange={this.handleChange} />
                                    <div style={{ fontSize: 12, color: "red" }}>
                                        {this.state.ZipCodeError}
                                    </div>
                                </div>
                            </div>
                            <div className="form-row"> 
                            <div className="col-md-4 col-sm-6 px-2 counter">
                                    <label className="text-muted fontsize12">Company Phone</label>
                                    <div className="relative">
                                        <span className="codephone">+20</span>
                                    <input type="number" className={"form-control badge-pill pl-5 p-3 " + (this.state.CompanyPhoneError ? 'is-invalid' : '')} placeholder="Company Phone" name="CompanyPhone" value={CompanyPhone} onChange={this.handleChange} />
                                    </div>

                                    <div style={{ fontSize: 12, color: "red" }}>
                                        {this.state.CompanyPhoneError}
                                    </div>
                                </div>
                                <div className="col-md-6 col-sm-6 px-2">
                                    <MapsNewOrder  key={this.state.data}  state={this.state}  setStatecoordinatesaddress_alias={this.setStatecoordinatesaddress_alias} />
                                    <div className="col-md-12 px-3  px-lg-5">
                                        <label className="text-muted fontsize12">Location</label>
                                        <div className="form-group pb-0 mb-1 relative search_div" id="pac-container">
                                            <img className="mr-1 img_input" src={searchbule} alt="search" />
                                            <input type="text " id="pac-input" className={"pl-5 search_input form-control badge-pill " + (this.state.address_nameError ? 'is-invalid' : '')} placeholder="Location" name="address_name" value={this.state.address_name} onChange={this.handleChange} />
                                            <div style={{ fontSize: 12, color: "red" }}>
                                                {this.state.address_nameError}
                                            </div>
                                        </div>
                                        
                                        <div id="map"></div>
                                        <div className="form-group col-12 text-left mt-2">
                                            <label >Adrress Details</label>
                                            <input type="text" className={"form-control badge-pill p-3 " + (this.state.address_aliasError ? 'is-invalid' : '')} placeholder="Adrress Details" name="address_alias" value={this.state.address_alias} onChange={this.handleChange} />
                                            <div style={{ fontSize: 12, color: "red" }}>
                                                {this.state.address_aliasError}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div className="text-center d-flex justify-content-around my-2 flex-wrap ">
                                <button onClick={this.handleSubmitEditinfo} className="btn badge-pill p-2 pl-1 px-3 my-2 border shadow bg-white" ><img className="mr-1" src={iconpen} alt="iconpen" />UPDATE</button>
                                <button onClick={this.getinfo} className="btn badge-pill p-2 pl-1 px-3 my-2 border shadow bg-danger text-white " ><img className="mr-1 " src={closeicon} alt="iconclose" />CANCEL</button>
                            </div>
                            <p className="col-6 mt-2 p-0 fontsize4 font-weight-bold ">Settings</p>
                            <hr />
                            <div className="">
                                <div className="accordion" id="accordionExample">
                                    <div className="">
                                        <div className=" col-12 change row">
                                            <div className="col-md-4 " id="headingOne">
                                                    <button className="btn border shadow m-2" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne" onClick={this.resetsomvar}>
                                                        Change Email Address
                                            </button>
                                            </div>
                                            <div className="col-md-4" id="headingTwo">
                                                    <button className="btn border shadow m-2" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo" onClick={this.resetsomvar}>
                                                        Change phone 
                                            </button>
                                            </div>
                                            <div className="col-md-4" id="headingThree">
                                                    <button className="btn border shadow m-2" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree" onClick={this.resetsomvar}>
                                                        Change Password
                                            </button>
                                            </div>
                                        </div>
                                        <div id="collapseOne" className="collapse " aria-labelledby="headingOne" data-parent="#accordionExample">
                                            <div className="border shadow p-3">
                                                <div className="col-md-4 col-sm-6 px-2">
                                                    <label className="text-muted fontsize12">Email address</label>
                                                    <input type="email" className="form-control  badge-pill" placeholder="Email address" name="email" value={email} onChange={this.handleChange} />
                                                    <div style={{ fontSize: 12, color: "red" }}>
                                                        {this.state.emailError}
                                                    </div>
                                                </div>
                                                <div className="col-md-4 col-sm-6 px-2">
                                                    <label className="text-muted fontsize12">password</label>
                                                    <input type="password" className="form-control  badge-pill" placeholder="your password" name="password" value={password} onChange={this.handleChange} />
                                                    <div style={{ fontSize: 12, color: "red" }}>
                                                        {this.state.passwordError}
                                                    </div>
                                                </div>
                                                {(this.state.errordataEmailmessage ?
                                                    <div className="px-2" style={{ fontSize: 12, color: "red" }}>
                                                        {this.state.errordatamessageEmailtext}
                                                    </div> : '')}

                                                <div className="text-center d-flex justify-content-around my-2 flex-wrap ">
                                                    <button onClick={this.handleSubmitemail} type="submit" className="btn badge-pill p-2 pl-1 px-3 my-2 border shadow bg-white" ><img className="mr-1" src={iconpen} alt="iconpen" />UPDATE </button>
                                                    <button onClick={this.getinfo} className="btn badge-pill p-2 pl-1 px-3 my-2 border shadow bg-danger text-white " ><img className="mr-1 " src={closeicon} alt="iconclose" />CANCEL</button>
                                                </div>

                                            </div>
                                        </div>
                                        <div id="collapseTwo" className="collapse " aria-labelledby="headingTwo" data-parent="#accordionExample">
                                            <div className="border shadow p-3  ">
                                                <div className="col-md-4 px-2">
                                                    <label className="text-muted fontsize12">phone</label>
                                                    <div className="relative">
                                                    <span className="codephone">+20</span>

                                                    <input type="number" className="pl-5 form-control  badge-pill" placeholder="phone" name="phone" value={phone} onChange={this.handleChange} />
                                                    </div>

                                                    <div style={{ fontSize: 12, color: "red" }}>
                                                        {this.state.phoneError}
                                                    </div>
                                                </div>
                                                <div className="col-md-4 px-2">
                                                    <label className="text-muted fontsize12">password</label>
                                                    <input type="password" className="form-control  badge-pill" placeholder="your password" name="phone" name="password" value={password} onChange={this.handleChange} />
                                                    <div style={{ fontSize: 12, color: "red" }}>
                                                        {this.state.passwordError}
                                                    </div>
                                                </div>
                                                {(this.state.errordataPhonemessage ?
                                                    <div className="px-2" style={{ fontSize: 12, color: "red" }}>
                                                        {this.state.errordatamessagePhonetext}
                                                    </div> : '')}
                                                {(this.state.Verify ? ''
                                                    : (this.state.oldphone===phone?'':<div className="text-center d-flex justify-content-around my-2 flex-wrap ">
                                                        <button onClick={this.handleSubmitphone} type="submit" className="btn badge-pill p-2 pl-1 px-3 my-2 mx-auto border shadow bg-white" >Send Code</button>
                                                    </div>))}

                                                <div className="col-md-6">
                                                    {(this.state.Verify ?
                                                        <div className=" counter" >
                                                            <div className="pt-5 pb-3 ">
                                                                <div className=" px-lg-5 nocounter">
                                                                    <label className="text-muted fontsize12">Verify your phone number</label>
                                                                    <input type="number" className={"form-control badge-pill col-md-8 p-3 " + (this.state.codeError ? 'is-invalid' : '')} placeholder="Enter verification " name="code" onChange={this.handleChange} value={this.state.code} />
                                                                </div>
                                                                <div className="px-lg-5 py-1" style={{ fontSize: 12, color: "red" }}>
                                                                    {this.state.codeError}
                                                                </div>
                                                                {(this.state.errordataPhoneVerifymessage ?
                                                                    <div className="px-lg-5 py-1" style={{ fontSize: 12, color: "red" }}>
                                                                        {this.state.errordatamessagePhoneVerifytext}
                                                                    </div> : '')}
                                                            </div>

                                                            <div className="text-center d-flex justify-content-around my-2 flex-wrap ">
                                                                <button onClick={this.handleSubmitVerify} type="submit" className="btn  badge-pill p-2 pl-1 px-3  border shadow btn-primary" >confirm</button>
                                                            </div>
                                                        </div>
                                                        :
                                                        ''
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div id="collapseThree" className="collapse " aria-labelledby="headingThree" data-parent="#accordionExample">
                                            <div className="border shadow p-3">
                                                <div className="col-md-4 col-sm-6 px-2">
                                                    <label className="text-muted fontsize12">Current password</label>
                                                    <input type="password" className="form-control  badge-pill" placeholder="Current password" name="password" value={password} onChange={this.handleChange} />
                                                    <div style={{ fontSize: 12, color: "red" }}>
                                                        {this.state.passwordError}
                                                    </div>
                                                </div>
                                                <div className="col-md-4 col-sm-6 px-2">
                                                    <label className="text-muted fontsize12">New password</label>
                                                    <input type="password" className="form-control  badge-pill" placeholder="New password" name="Newpassword" value={Newpassword} onChange={this.handleChange} />
                                                    <div style={{ fontSize: 12, color: "red" }}>
                                                        {this.state.NewpasswordError}
                                                    </div>
                                                </div>
                                                {(this.state.errordatapasswordmessage ?
                                                    <div className="px-2" style={{ fontSize: 12, color: "red" }}>
                                                        {this.state.errordatamessagepasswordtext}<br/>
                                                        <Link to="/ForgetPassword"><span className="pointer fontsize11 text-muted py-1 my-1">Forget Password ?</span></Link>

                                                    </div> : '')}
                                                <div className="text-center d-flex justify-content-around my-2 flex-wrap ">
                                                    <button onClick={this.handleSubmitChangepassword} className="btn badge-pill p-2 pl-1 px-3 my-2 border shadow bg-white" ><img className="mr-1" src={iconpen} alt="pen" />UPDATE</button>
                                                    <button onClick={this.getinfo} className="btn badge-pill p-2 pl-1 px-3 my-2 border shadow bg-danger text-white " ><img className="mr-1 " src={closeicon} alt="iconclose" />CANCEL</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {(this.state.res_doneEdit ? <HandleRes title="  Your information has been changed" stylecss="alert-success" /> : '')}
                {(this.state.res_doneChangeEmail ? <HandleRes title="Please check your Inbox to vertify your Account" stylecss="alert-success" /> : '')}
                {(this.state.res_doneChangepassword ? <HandleRes title=" Your Password has been changed" stylecss="alert-success" /> : '')}
                {(this.state.res_doneChangephone ? <HandleRes title="Your phone has been changed" stylecss="alert-success" /> : '')}
                {(this.state.networkError ? <HandleRes title="You are currently offline." stylecss="alert-danger" /> : '')}
                {(this.state.errordatamessage ? <HandleRes title={this.state.errordatamessagetext} stylecss="alert-danger" /> : '')}
                {(this.state.hasError ? <HandleRes title="sorry there was a problem with your request" stylecss="alert-danger" /> : '')}

            </div>
        )
    }
}
export default Profile;